<template>
  <WorldWideList :config="config" />
</template>

<script>
import WorldWideList from "../../components/WorldWideList/WorldWideList.vue";

export default {
  name: "app",
  components: {
    WorldWideList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
